import Dexie from "dexie";

export const db = new Dexie("mp_index");

export const indexedDbTableNames = [
  "ticket_violations",
  "ticket_violations_warnings",
  "commercial_violation_containers",
  "vehicle_makes",
  "vehicle_models",
  "offense_violations",
  "municipal_violations",
];

export const tableSchema = indexedDbTableNames.reduce((schema, tableName) => {
  schema[tableName] = "&id";
  return schema;
}, {});

db.version(12).stores(tableSchema);
